import { styled } from 'styled-components';

export const Container = styled.div`
  align-items: stretch;
  display: flex;
  justify-content: space-between;
  gap: 0.5rem;
  padding: 1rem 0.5rem;

  @media print {
    display: none;
  }
`;
